module.exports = "/images/lc.svg?4e0491cecc1246062484daccb1b3357e";